var _ellipse, _ellipse2, _path, _ellipse3, _ellipse4, _path2, _ellipse5, _circle, _path3, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCosmos = function SvgCosmos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 350 225"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.531,
    cy: 112.491,
    fill: "#000",
    rx: 91.531,
    ry: 112.491,
    transform: "matrix(1 0 .10453 .99452 .546 .35)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cosmos_svg__a",
    width: 186,
    height: 225,
    x: 11,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.531,
    cy: 112.491,
    fill: "#fff",
    rx: 91.531,
    ry: 112.491,
    transform: "matrix(1 0 .10453 .99452 .546 .35)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.294 141.687h56.441v39.923H10.294zM20.891 189.096h144.184v3.811H20.891zM8.427 120.865h144.184v3.811H8.427zM8.307 36.36h38.696v26.276H8.307zM27.75 23.267h33.182v6.527H27.75z",
    mask: "url(#cosmos_svg__a)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cosmos_svg__c",
    width: 169,
    height: 221,
    x: 28,
    y: -2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.164,
    cy: 110.723,
    fill: "#fff",
    rx: 83.164,
    ry: 110.723,
    transform: "matrix(1 0 .10453 .99452 17.577 -1.452)"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.164,
    cy: 110.723,
    fill: "url(#cosmos_svg__b)",
    rx: 83.164,
    ry: 110.723,
    transform: "matrix(1 0 .10453 .99452 17.577 -1.452)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#554F5B",
    d: "M111.347 187.72c2.44 23.214-14.505 42.033-37.846 42.033-23.342 0-44.242-18.819-46.682-42.033-2.44-23.213 14.505-42.032 37.846-42.032 23.342 0 44.242 18.819 46.682 42.032",
    mask: "url(#cosmos_svg__c)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.718,
    cy: 33.877,
    fill: "#E8F0C6",
    rx: 2.903,
    ry: 3.175,
    transform: "rotate(-15 94.718 33.877)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.987,
    cy: 17.987,
    r: 17.237,
    fill: "#554F5B",
    stroke: "#554F5B",
    strokeWidth: 1.5,
    transform: "matrix(1 0 .10453 .99452 115.696 56.337)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cosmos_svg__d)",
    d: "M94.635 143.419 267.714 63.6l27.07 31.648-17.063 37.411-185.5 17.805z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E8F0C6",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m63.421 72.324 2.614 24.863M76.676 84.258h-24"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#E8F0C6",
    transform: "matrix(1 0 .10453 .99452 60.258 80.28)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cosmos_svg__e",
    width: 102,
    height: 116,
    x: 233,
    y: 37,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M334.186 106.957c2.747 31.39-16.454 45.668-43.831 45.668s-53.938-24.906-56.684-56.296 18.298-59.163 45.674-59.163c28.231-2.06 52.095 38.4 54.841 69.791"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M333.186 106.957c2.747 31.39-16.454 45.668-43.831 45.668s-53.938-24.906-56.684-56.296 18.298-59.163 45.674-59.163c28.231-2.06 52.095 38.4 54.841 69.791",
    mask: "url(#cosmos_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232.415 55.678h38.696v8.32h-38.696zM227.488 83.235h38.696v35.957h-38.696zM248.619 139.163h49.023v5.467h-49.023z",
    mask: "url(#cosmos_svg__e)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    stroke: "#3B58E3",
    strokeWidth: 2,
    d: "M343.262 93.837c2.731 31.215-17.242 56.284-44.31 56.284s-51.427-25.069-54.158-56.285 17.241-56.284 44.309-56.284c27.069 0 51.428 25.069 54.159 56.285Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M279.404 78.45h12.995l-1.616-15.376h-12.995c-8.555 0-14.768 6.885-13.876 15.376.294 2.8 1.335 5.439 2.889 7.688 2.2-4.59 6.869-7.688 12.603-7.688M281.023 93.85c-5.735 0-11.055-3.098-14.219-7.688-1.08 2.272-1.568 4.888-1.273 7.688.892 8.491 8.553 15.376 17.108 15.376h12.995l-1.616-15.376zM308.651 109.223h-12.995l1.616 15.376h12.995c8.556 0 14.769-6.885 13.876-15.376-.294-2.8-1.334-5.439-2.889-7.688-2.2 4.59-6.868 7.688-12.603 7.688"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M307.035 93.849c5.735 0 11.055 3.098 14.22 7.687 1.079-2.272 1.567-4.888 1.273-7.687-.893-8.492-8.553-15.376-17.109-15.376h-12.995l1.616 15.376z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos_svg__b",
    x1: 3.447,
    x2: 151.91,
    y1: 110.723,
    y2: 161.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos_svg__d",
    x1: 94.433,
    x2: 247.148,
    y1: 143.864,
    y2: 39.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#BECBFD"
  })))));
};
export default SvgCosmos;